export default __webpack_public_path__ + "static/media/790.98d9db3e.gif";